import about from "../../assets/images/about/about.jpg"
const aboutData = {
    aboutUsCmsData: {
        page_heading: 'About us',
        title: "Our Story",
        breadcrumb: [
            { name: "Home", className: "breadcrumb-item", link: "/" },
            { name: "Page", className: "breadcrumb-item", link: "#" },
            { name: "About us", className: "breadcrumb-item active" }
        ],
        img: about,
        our_story: {
            title: 'Our Story',
            video_id: 'L61p2uyiMSo',
            img_url: 'about.jpg',
            description: [
                {
                    content: 'Embark on a journey with ',
                    highlight: false,
                },
                {
                    content: 'Subul Contracting',
                    highlight: true,
                },
                {
                    content:
                        " - your partner in creating a legacy of comfort and innovation. Established in 2012, we go beyond merely providing HVAC solutions; we generate awareness, drive traffic, and foster connections. Our story is woven with dedication and expertise. Dummy text is a placeholder used by designers, but our commitment is real. Since our inception in 2012, we've embraced the spirit of progress and quality, just as the HVAC industry has evolved since its inception in the 19th century. Join us in shaping the future of climate control.",
                    highlight: false,
                },
            ],
        },
        key_features: {
            description: [
                {
                    content: 'Experience the power of cutting-edge HVAC technology with ',
                    highlight: false,
                },
                {
                    content: 'Subul Contracting',
                    highlight: true,
                },
                {
                    content:
                        '. Our solutions are designed to optimize climate control, enhance air quality, and provide smart, energy-efficient systems. With remote access and professional maintenance services, we ensure year-round comfort. Trust in our reliable security features and enjoy a customer satisfaction guarantee.',
                    highlight: false,
                },
            ],
            key_features_list: [
                {
                    icon: 'thermometer',
                    title: 'Efficient Climate Control',
                },
                {
                    icon: 'wind',
                    title: 'Air Quality Optimization',
                },
                {
                    icon: 'cpu',
                    title: 'Smart HVAC Solutions',
                },
                {
                    icon: 'wifi',
                    title: 'Remote Access and Control',
                },
                {
                    icon: 'zap',
                    title: 'Energy-Efficient Systems',
                },
                {
                    icon: 'tool',
                    title: 'Professional Maintenance Services',
                },
                {
                    icon: 'sun',
                    title: 'Year-Round Comfort',
                },
                {
                    icon: 'shield',
                    title: 'Reliable Security Features',
                },
                {
                    icon: 'thumbs-up',
                    title: 'Customer Satisfaction Guarantee',
                },
                {
                    icon: 'user-check',
                    title: 'Certified Technicians',
                },
                {
                    icon: 'cloud-snow',
                    title: 'Adaptive Cooling Technology',
                },
                {
                    icon: 'headphones',
                    title: '24/7 Customer Support',
                },
                {
                    icon: 'globe',
                    title: 'Global HVAC Solutions',
                },
                {
                    icon: 'clock',
                    title: 'Scheduled Maintenance Plans',
                },
                {
                    icon: 'bar-chart',
                    title: 'Optimized Performance Metrics',
                },
            ],
        },
        seeMore: "See More",
        hideMore: "Hide More",
    },
};

export { aboutData }